import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";
import { French } from "flatpickr/dist/l10n/fr.js";
import { Italian } from "flatpickr/dist/l10n/it.js";
import currentLocale from './locale';

const locales = {
    'de': German,
    'fr': French,
    'it': Italian,
}

flatpickr('.datepicker', {
    dateFormat: 'd.m.Y',
    allowInput: true,
    locale: locales[currentLocale] || 'en',
});

flatpickr('.datetimepicker', {
    enableTime: true,
    time_24hr: true,
    dateFormat: 'd.m.Y H:i',
    allowInput: true,
    locale: locales[currentLocale] || 'en',
})


// WEBPACK FOOTER //
// ./themes/wild/assets/js/datepicker.js